import { useCallback } from 'react';
import { sdk } from 'sdk';

const useCTStock = () => {
  const getStoreStock = useCallback(async (channels: string[], skus: string[]) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.ctstock.getStoreStock({ channels, skus });
    if (!res.isError) {
      return res.data;
    }

    return [];
  }, []);

  return { getStoreStock };
};

export default useCTStock;
